// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import ChristmasIsland from '../_raw/flag/icon_flag_christmas_island.png';

export default () => <img src={ChristmasIsland} alt="ChristmasIsland" />;
